import {
    BASE_URL,
    getSwishPayeeAlias,
    initiateSwishPaymentApi,
    getSwishPaymentStatus,
} from "../queries/swish";

/** Launch swish:// via anchor + fallback (call from component on user click). */
export function openSwishUrlCompat(url) {
    try {
        const a = document.createElement("a");
        a.href = url;
        a.style.display = "none";
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            try { window.location.href = url; } catch {}
        }, 50);
    } catch {
        try { window.location.href = url; } catch {}
    }
}

export async function fetchPayeeAlias(token) {
    const res = await getSwishPayeeAlias(token);
    const alias = res?.data?.swishAliasNumber ?? res?.swishAliasNumber ?? null;
    if (!alias) throw new Error("Missing Swish payee alias from settings");
    return String(alias).trim();
}

export function buildPaymentData({
                                     alias,
                                     userId,
                                     cartItems,
                                     amount,
                                     currency = "SEK",
                                     message = "K\u00f6p inuti mobilapplikation",
                                     fridgeId,
                                 }) {
    return {
        userId,
        payeePaymentReference: alias,
        callbackUrl: `${BASE_URL}/callback`,
        payeeAlias: alias,
        amount,
        currency,
        message,
        fridgeId,
        items: (cartItems || []).map((item) => ({
            productId: item.id,
            productName: item.title,
            quantity: item.quantity,
            price: item.price,
        })),
    };
}

/** Initiate Swish — return deep link & ids (do not launch here). */
export async function initiateSwish({ token, paymentData, fridgeId }) {
    // Log payload in development for debugging
    if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production") {
        /* eslint-disable-next-line no-console */
        console.log("[Swish] initiate payload =>\n" + JSON.stringify(paymentData, null, 2));
    }

    const responseData = await initiateSwishPaymentApi(paymentData, token);

    const callbackUrl = `${window.location.origin}/swish-bridge.html?fridgeId=${encodeURIComponent(
        fridgeId
    )}&paymentId=${encodeURIComponent(responseData.id)}`;

    const swishUrl = `swish://paymentrequest?token=${encodeURIComponent(
        responseData.token
    )}&callbackurl=${encodeURIComponent(callbackUrl)}`;

    return {
        paymentRequestId: responseData.id,
        swishUrl,
        callbackUrl,
    };
}

function extractStatusUpper(resp) {
    const raw = resp?.status ?? resp?.data?.status ?? resp?.data?.Status ?? resp?.Status ?? resp?.state ?? resp?.data?.state;
    return String(raw || "").toUpperCase();
}

/** react-query options for polling the payment status */
export function makeStatusQueryOptions(paymentRequestId, { onPaid, onTerminal, onError } = {}) {
    return {
        queryKey: ["swishStatus", paymentRequestId],
        queryFn: () => getSwishPaymentStatus(paymentRequestId),
        enabled: !!paymentRequestId,
        refetchInterval: (query) => {
            const data = query?.state?.data;
            const up = extractStatusUpper(data);
            const terminal = up === "PAID" || ["CANCELLED", "DECLINED", "ERROR"].includes(up);
            return terminal ? false : 2000;
        },
        refetchIntervalInBackground: true,
        retry: 0,
        onSuccess: (resp) => {
            const up = extractStatusUpper(resp);
            const qrCode = resp?.qrCode ?? resp?.data?.qrCode ?? resp?.QRCode;
            const qrValidUntil = resp?.qrValidUntil ?? resp?.data?.qrValidUntil ?? resp?.qrExpiry ?? resp?.qrExpiresAt;
            if (up === "PAID") {
                onPaid?.({ status: up, qrCode, qrValidUntil, raw: resp });
            } else if (["CANCELLED", "DECLINED", "ERROR"].includes(up)) {
                onTerminal?.(up, resp);
            }
        },
        onError: (e) => {
            onError?.(e);
        },
    };
}




export { getSwishPaymentStatus };
